import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.myTeam.title',
    defaultMessage: 'My Team',
  },
  directReports: {
    id: 'pages.myTeam.directReports',
    defaultMessage: 'Direct Reports',
  },
  subordinates: {
    id: 'pages.myTeam.subordinates',
    defaultMessage: 'Subordinates',
  },
  profiles: {
    id: 'pages.myTeam.profiles',
    defaultMessage: 'Profiles',
  },
  inactiveEmployees: {
    id: 'pages.myTeam.inactiveEmployees',
    defaultMessage: 'Inactive Employees',
  },
  sharedScorecards: {
    id: 'pages.myTeam.sharedScorecards',
    defaultMessage: 'Shared Scorecards',
  },
  deletedScorecards: {
    id: 'pages.myTeam.deletedScorecards',
    defaultMessage: 'Deleted Scorecards',
  },
  extraMultiplierTooltip07: {
    id: 'pages.myTeam.extraMultiplierTooltip07',
    defaultMessage: 'External escalation(s)',
  },
  extraMultiplierTooltip09: {
    id: 'pages.myTeam.extraMultiplierTooltip09',
    defaultMessage: 'Internal escalation(s)',
  },
  extraMultiplierTooltip11: {
    id: 'pages.myTeam.extraMultiplierTooltip11',
    defaultMessage: 'Positive feedback from Unit/Department Managers level',
  },
  extraMultiplierTooltip13: {
    id: 'pages.myTeam.extraMultiplierTooltip13',
    defaultMessage: 'Positive feedback from the customer',
  },
  currentReviewCycle: {
    id: 'pages.myTeam.currentReviewCycle',
    defaultMessage: 'Current Review Cycle: {name}',
  },
  pastReviewCycle: {
    id: 'pages.myTeam.pastReviewCycle',
    defaultMessage: 'Past Review Cycle: {name}',
  },
  noCycle: {
    id: 'pages.myTeam.noCycle',
    defaultMessage: 'No Review Cycle',
  },
  spr: {
    id: 'pages.myTeam.spr',
    defaultMessage: 'SPR',
  },
  score: {
    id: 'pages.myTeam.score',
    defaultMessage: 'SCORE',
  },
});
